const MBUS_PLAYBACK_RATE = 'MBUS_PLAYBACK_RATE';

export const getSavedPlaybackRate = (): string | null => {
  return localStorage.getItem(MBUS_PLAYBACK_RATE);
};

export const savePlaybackRate = (rate: number) => {
  localStorage.setItem(MBUS_PLAYBACK_RATE, String(rate));
};
